// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"2f1a8699","143":"2efd775e","248":"843a1715","270":"4daa29ce","636":"87f051ed","759":"3fa5309d","787":"d7ece244","788":"7a23fbdd","972":"7dad28af"}[chunkId] + ".chunk.js";
};